module.exports = __webpack_public_path__ + "img/swiper1.9b8e8b07.jpg";